import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import backdrop from '@/assets/backdrop.png';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import "./style.scss";

function BannerImg(props: any) {
  const { id, data, mark, pId, mallTest } = props;

  const clickBannerImg = () => {
    // 点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      linkUrl: data.link,
      compId: data.siteUserBannerId,
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_tltupian_click",
      dd.baseParams,
      extendParams
    );
    if (data.link) {
      window.location.href = utils.linkUrl(data.link, 200015, mallTest);
    }
  };

  useEffect(() => {
    if (!!data.siteUserBannerId && mark.pageType === "mall") {
      // 曝光埋点
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        linkUrl: data.link,
        compId: data.siteUserBannerId,
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_tltupian_show",
        dd.baseParams,
        extendParams
      );
    }
  }, [JSON.stringify(data), JSON.stringify(mark)]);

  return (
    <div key={id} className="tabHome-item tabHome-item-banner">
      <img
        src={data.picture}
        style={{
          width: "100%",
        }}
        onClick={() => clickBannerImg()}
      />
    </div>
  );
}

export default BannerImg;
